import { RecruitmentSpecificationDTO } from '../DTO/Assessments/AssessmentSpecificationDTO';

export type AssessmentStatus = 'Active' | 'Closed';

export function RecruitmentSpecificationDTO2Status(spec: RecruitmentSpecificationDTO): AssessmentStatus | undefined {
    return spec.assessmentStatus;
}
